export default "__VITE_ASSET__Bc0j1B5t__"